import { render } from "./TheFooter.vue?vue&type=template&id=4c25d3d8&scoped=true"
const script = {}

import "./TheFooter.vue?vue&type=style&index=0&id=4c25d3d8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4c25d3d8"

export default script